// Initial state objects
import { InitialData } from 'src/types';
import { CoordsUtils } from 'src/utils';
import { DEFAULT_COLOR } from './defaults';

/**
 * Initial data structure for a new diagram
 */
export const INITIAL_DATA: InitialData = {
  title: 'Untitled',
  version: '',
  icons: [],
  colors: [DEFAULT_COLOR],
  items: [],
  views: [],
  fitToView: false
};

/**
 * Initial UI state (zoom, scroll position)
 */
export const INITIAL_UI_STATE = {
  zoom: 1,
  scroll: {
    position: CoordsUtils.zero(),
    offset: CoordsUtils.zero()
  }
};

/**
 * Initial scene state (connectors, text boxes)
 */
export const INITIAL_SCENE_STATE = {
  connectors: {},
  textBoxes: {}
};
